(() => {
  const ENDPOINT = "https://script.google.com/macros/s/AKfycbxnrAjMnCLBa3zQTVT6dOxuKfU6nksaX0r9TZ3Tu8tLDZAyfDtGi-XXC2GiHyAcdrOT/exec";
  const $ = (id) => document.getElementById(id);

  function qs(){
    const u = new URL(window.location.href);
    return {
      order_id: u.searchParams.get("order_id") || "",
      t: u.searchParams.get("t") || ""
    };
  }

  function setStatus(msg, ok=false){
    const el = $("arboContratoStatus");
    if (!el) return;
    el.textContent = msg || "";
    el.style.color = ok ? "#0a7a2f" : "#b00020";
  }

  function extractDriveId(url){
    const s = String(url||"");
    let m = s.match(/\/file\/d\/([a-zA-Z0-9_-]+)/);
    if (m) return m[1];
    m = s.match(/[?&]id=([a-zA-Z0-9_-]+)/);
    if (m) return m[1];
    return "";
  }

  function drivePreview(url){
    const id = extractDriveId(url);
    if (!id) return url;
    return `https://drive.google.com/file/d/${id}/preview`;
  }
  function driveView(url){
    const id = extractDriveId(url);
    if (!id) return url;
    return `https://drive.google.com/file/d/${id}/view`;
  }
  function driveDownload(url){
    const id = extractDriveId(url);
    if (!id) return url;
    return `https://drive.google.com/uc?export=download&id=${id}`;
  }

  // ===== HELPERS DE TRACKING (NOVOS) =====
  function getStored(key){
    try {
      return localStorage.getItem(key) || sessionStorage.getItem(key) || "";
    } catch(e){
      return "";
    }
  }

  function getParamFromUrl(name){
    try {
      return new URL(window.location.href).searchParams.get(name) || "";
    } catch(e){
      return "";
    }
  }
  // =========================================

  function jsonp(url, callbackName){
    return new Promise((resolve, reject) => {
      const cb = callbackName || ("__ARBO_CB_" + Math.random().toString(16).slice(2));
      const s = document.createElement("script");
      const timer = setTimeout(() => {
        cleanup();
        reject(new Error("timeout"));
      }, 45000);

      function cleanup(){
        clearTimeout(timer);
        try{ delete window[cb]; }catch(e){ window[cb] = undefined; }
        try{ s.remove(); }catch(e){}
      }

      window[cb] = (payload) => {
        cleanup();
        resolve(payload);
      };

      const u = new URL(url);
      u.searchParams.set("callback", cb);
      s.src = u.toString();
      s.onerror = () => { cleanup(); reject(new Error("jsonp_error")); };
      document.head.appendChild(s);
    });
  }

  function postViaIframe(payload){
    return new Promise((resolve, reject) => {
      const reqId = "req_" + Math.random().toString(16).slice(2);
      payload._req_id = reqId;

      const iframe = document.createElement("iframe");
      iframe.style.display = "none";
      iframe.name = "arbo_iframe_" + reqId;
      document.body.appendChild(iframe);

      const form = document.createElement("form");
      form.style.display = "none";
      form.method = "POST";
      form.action = ENDPOINT;
      form.target = iframe.name;

      Object.keys(payload).forEach((k) => {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = k;
        input.value = String(payload[k] ?? "");
        form.appendChild(input);
      });

      const timer = setTimeout(() => {
        cleanup();
        reject(new Error("timeout"));
      }, 45000);

      function onMessage(ev){
        try{
          if (!ev || !ev.data) return;
          const data = ev.data;
          if (data._req_id !== reqId) return;
          clearTimeout(timer);
          cleanup();
          resolve(data);
        } catch(e){}
      }

      function cleanup(){
        window.removeEventListener("message", onMessage);
        try{ form.remove(); }catch(e){}
        try{ iframe.remove(); }catch(e){}
      }

      window.addEventListener("message", onMessage);
      document.body.appendChild(form);
      form.submit();
    });
  }

  // cookies p/ matching
  function getCookie(name){
    const m = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/[$()*+./?[\\\]^{|}-]/g, '\\$&') + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : "";
  }

  function setCookie(name, value, days = 90) {
    try {
      const maxAge = days * 24 * 60 * 60;
      document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; path=/; max-age=${maxAge}; samesite=lax`;
    } catch (e) {}
  }

  function getFbclidFromUrl() {
    try {
      const u = new URL(window.location.href);
      return u.searchParams.get("fbclid") || "";
    } catch (e) {
      return "";
    }
  }

  function buildFbcFromFbclid(fbclid){
    if (!fbclid) return "";
    return `fb.1.${Date.now()}.${fbclid}`;
  }

  function ensureFbc() {
    // 1) cookie primeiro
    const cookieFbc = getCookie("_fbc");
    if (cookieFbc) return cookieFbc;

    // 2) tenta pegar fbclid da URL e gerar fbc
    const fbclid = getFbclidFromUrl();
    if (fbclid) {
      const fbc = buildFbcFromFbclid(fbclid);
      if (fbc) {
        setCookie("_fbc", fbc);
        try { localStorage.setItem("_arbo_fbc", fbc); } catch(e){}
        return fbc;
      }
    }

    // 3) fallback de storage (se veio de algum passo anterior)
    try {
      const ls = localStorage.getItem("_arbo_fbc") || "";
      if (ls) return ls;
    } catch(e){}

    return "";
  }

  // ===== NOVO: também salva tracking IDs caso o cliente venha com gclid/fbclid no link de aceite =====
  function refreshTrackingFromUrl(){
    const now = String(Date.now());

    const gclid = getParamFromUrl("gclid");
    const wbraid = getParamFromUrl("wbraid");
    const gbraid = getParamFromUrl("gbraid");
    const gad_source = getParamFromUrl("gad_source");
    const fbclid = getParamFromUrl("fbclid");

    try {
      if (gclid)      { localStorage.setItem("arb_gclid", gclid);    localStorage.setItem("arb_gclid_at", now); }
      if (wbraid)     { localStorage.setItem("arb_wbraid", wbraid);  localStorage.setItem("arb_wbraid_at", now); }
      if (gbraid)     { localStorage.setItem("arb_gbraid", gbraid);  localStorage.setItem("arb_gbraid_at", now); }
      if (gad_source) { localStorage.setItem("arb_gad_source", gad_source); }
      if (fbclid)     { localStorage.setItem("arbo_fbclid", fbclid); }
    } catch(e){}
  }
  // =====================================================================================================

  async function init(){
    refreshTrackingFromUrl(); // 👈 garante que se o link vier com gclid/fbclid, fica salvo

    const { order_id, t } = qs();
    console.log("[ARBO-CONTRATO] params:", { order_id, t_len: (t||"").length });

    const frame = $("arboPdfFrame");
    const openBtn = $("arboPdfOpen");
    const downBtn = $("arboPdfDownload");
    const check = $("arboAceiteCheck");
    const acceptBtn = $("arboAceitarBtn");
    const msgEl = $("arboAceiteMsg");

    if (!order_id || !t){
      setStatus("Link inválido. Solicite um novo link ao vendedor.");
      return;
    }

    try{
      setStatus("Carregando contrato...", true);

      const u = new URL(ENDPOINT);
      u.searchParams.set("action", "contract_pm");
      u.searchParams.set("order_id", order_id);
      u.searchParams.set("t", t);

      const payload = await jsonp(u.toString());
      if (!payload || !payload.ok) throw new Error(payload?.error || "Falha ao carregar.");

      const alreadyAccepted = payload.is_active === false;

      window.__ARBO_VALUE__ = Number(payload.value) || 0;

      const pdf_url = payload.pdf_url || "";
      if (!pdf_url) throw new Error("PDF não encontrado para este pedido.");

      const preview = drivePreview(pdf_url);
      const view = driveView(pdf_url);
      const download = driveDownload(pdf_url);

      if (frame) frame.src = preview;
      if (openBtn) openBtn.href = view;
      if (downBtn) downBtn.href = download;

      if (alreadyAccepted) {
        setStatus("Este contrato já foi aceito anteriormente. O arquivo continua disponível para consulta.", true);
      } else {
        setStatus("Contrato carregado. Se estiver de acordo, confirme o aceite.", true);
      }

      if (acceptBtn){
        acceptBtn.addEventListener("click", async () => {
          try{
            if (!check || !check.checked){
              setStatus("Confirme a caixa de aceite para continuar.");
              return;
            }

            acceptBtn.disabled = true;
            acceptBtn.style.opacity = "0.7";
            if (msgEl) msgEl.textContent = "Confirmando aceite...";

            // ===== matching context (Meta) =====
            const fbp = getCookie("_fbp") || localStorage.getItem("_arbo_fbp") || "";
            const fbc = ensureFbc();
            const client_user_agent = navigator.userAgent || "";
            const event_source_url = window.location.href;
            const lead_click_id = localStorage.getItem("arbo_lead_click_id") || "";

            // ===== NOVO: tracking IDs do CLIENTE (Google + Meta fbclid) =====
            const gclid      = getStored("arb_gclid");
            const wbraid     = getStored("arb_wbraid");
            const gbraid     = getStored("arb_gbraid");
            const gad_source = getStored("arb_gad_source");
            const fbclid     = getStored("arbo_fbclid") || getStored("fbclid");
            // ================================================================

            // event_id para dedup
            const eventID = String(order_id || "").trim();

            // Pixel browser (se existir)
            if (typeof fbq === "function") {
              try {
                fbq("track", "Purchase",
                  { value: Number(window.__ARBO_VALUE__) || 0, currency: "BRL" },
                  { eventID }
                );
              } catch(e){}
            }

            // GA4 purchase
            if (window.dataLayer) {
              window.dataLayer.push({
                event: "purchase",
                transaction_id: eventID,
                value: Number(window.__ARBO_VALUE__) || 0,
                currency: "BRL"
              });
            }

            // Confirma aceite (server fará CAPI)
            const resp = await postViaIframe({
              action: "accept_contract",
              order_id,
              t,
              fbp,
              fbc,
              fbclid,             // 👈 NOVO
              gclid,              // 👈 NOVO
              wbraid,             // 👈 NOVO
              gbraid,             // 👈 NOVO
              gad_source,         // 👈 NOVO
              client_user_agent,
              event_source_url,
              lead_click_id
            });

            if (!resp || !resp.ok) throw new Error(resp?.error || "Falha ao confirmar.");

            setStatus("Aceite confirmado. Obrigado! ✅", true);
            if (msgEl) msgEl.textContent = "Aceite registrado.";
          } catch(err){
            console.error(err);
            setStatus("Não foi possível confirmar: " + (err?.message || "erro"));
            if (msgEl) msgEl.textContent = "";
            acceptBtn.disabled = false;
            acceptBtn.style.opacity = "1";
          }
        });
      }

    } catch(err){
      console.error(err);
      setStatus("Não foi possível carregar: " + (err?.message || "Falha ao carregar (JSONP)."));
    }
  }

  document.addEventListener("DOMContentLoaded", init);
})();